/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';

// eslint-disable-next-line no-unused-vars
// export const useBenefitDocuments = (params: { versionId: string; }) => {
export const useBenefitDocuments = (versionId: string) => {
  const result = useQuery({
    queryKey: ['benefits/documents'],
    queryFn: () => BenefitsService.getPlanDocument(versionId),
    enabled: true,
  });
  return result;
};
